export const ModuSignMethod = {
    KAKAO: 'KAKAO',                 // 카카오 알림톡 전송, 모바일번호 필요
    SECURE_LINK: 'SECURE_LINK',     // 대면서명, 모바일번호 필요 (1.모두싸인 API 에러 방지 용도),
    EMAIL: "EMAIL"                  // 이메일 전송, 이메일 주소 필요
}

export const CustomeSignMethod = {
    ...ModuSignMethod,
    DON_NEED_SIGN_ABORTED: "DON_NEED_SIGN_ABORTED",
    DON_NEED_SIGN_COMPLETED: "DON_NEED_SIGN_COMPLETED"
}

export const TemplateGroup = {
    인테리어: "인테리어",
    장비: "장비",
    영업: "영업",
    고객지원: "고객지원"
}

// ⚠️inapi: src/contracts/enums/contract.type.enum.ts 기준에 맞추기
export const ContractTypeEnum = {
    // 영업
    물품매매 : "물품매매",
    물품매매V2 : "물품매매V2", // 물품매매계약서_V2 다자간 서명
    물품매매V4 : "물품매매V4", // 물품매매계약서_V4 (2026-07-24 penny 개정: 물품명세 4항목, 카드일시불, 별첨2/3)
    매출프로모션 : "매출프로모션",
    BNK: "BNK",
    신협: "신협",
    ACTILINK : "ACTILINK",

    // 장비
    CADCAM : "CADCAM", // 동일한 계약서에 구분이 필요한 CADCAM(IOS) 상품이 존재함
    CT매매 : "CT매매",
    UnitChair : "UnitChair",
    서비스로봇 : "서비스로봇",
    ICTMotor: "ICTMotor",
    IOX: "IOX",
    BrightXray: "BrightXray",

    // 고객지원
    cbct설치확인서 : "cbct설치확인서",
    chair설치확인서 : "chair설치확인서",

    // deprecated
    공사계약 : "공사계약",
    하도급계약 : "하도급계약",
}